import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { gray } from 'src/templates/shared-theme/themePrimitives';
import { Card, CardContainer } from 'src/components/CardContainer';
import { AppContext } from 'src/AppContext';
import { clearSessionToken } from 'src/api/api';


const TextBox = styled(Typography)(({ theme }) => ({
  width: '100%',
  fontSize: '1rem',
  color: gray[500],
}));

export default function Me() {
  const { user, setUser } = useContext(AppContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    clearSessionToken();
    setUser(null);
    navigate('/');
  };

  return (
    <CardContainer direction="column" justifyContent="space-between">
      <Card 
        variant="outlined"
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 3,
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ width: 56, height: 56 }} src={user?.avatarURL} />
            <Typography component="h1" variant="h4">{user?.userName}</Typography>
          </Box>
          <Divider></Divider>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
            }}
          >
            <TextBox>Phone Number</TextBox>
            <TextBox>{user ? '+' + user.phoneNumber : 'Not Set'}</TextBox>
          </Box>
          <Divider></Divider>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
            }}
          >
            <TextBox>Email</TextBox>
            <TextBox>{user?.email || 'Not Set'}</TextBox>
          </Box>
          <Divider></Divider>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
            }}
          >
            <TextBox>Balance</TextBox>
            <TextBox>S${user?.balance || 0}</TextBox>
          </Box>
          <Divider></Divider>
          {user?.balance > 0 && (
            <>
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  alignItems: 'center',
                }}
              >
                <TextBox>Recent Balance Expiry</TextBox>
                <TextBox>
                  S${user?.expiringAmount || 0} expires on {user ? new Date(user.expiringAt * 1000).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' }) : ''}
                </TextBox>
              </Box>
              <Divider></Divider>
            </>
          )}
          <Button
            fullWidth
            variant="text"
            color="secondary"
            onClick={handleLogout}
            sx={{
              padding: 2,
              fontSize: '1.25rem',
            }}
          >
            Logout
          </Button>
        </Box>
      </Card>
    </CardContainer>
  );
}
